import React from "react";
import { severityColor, severityLabel } from "../utils/colors";

interface SeverityDistributionProps {
  distribution: Array<{ severity: number; count: number }>;
  total: number;
}

export const SeverityDistribution: React.FC<SeverityDistributionProps> = ({
  distribution,
  total,
}) => {
  if (!distribution.length) return null;

  // Ensure all 5 severity levels are represented
  const filled = [1, 2, 3, 4, 5].map((sev) => {
    const found = distribution.find((d) => d.severity === sev);
    return { severity: sev, count: found?.count ?? 0 };
  });

  const maxCount = Math.max(...filled.map((d) => d.count), 1);

  return (
    <div className="space-y-1.5">
      <h4 className="text-xs font-semibold text-fl-sand/70 uppercase tracking-wide">
        Severity Distribution
      </h4>
      {filled.map(({ severity, count }) => {
        const pct = total > 0 ? Math.round((count / total) * 100) : 0;
        const barWidth = maxCount > 0 ? (count / maxCount) * 100 : 0;
        return (
          <div key={severity} className="flex items-center gap-2 text-xs">
            <span className="w-16 text-fl-sand/60 truncate">
              {severityLabel(severity)}
            </span>
            <div className="flex-1 h-4 bg-white/5 rounded overflow-hidden">
              <div
                className="h-full rounded transition-all duration-500"
                style={{
                  width: `${barWidth}%`,
                  backgroundColor: severityColor(severity),
                  minWidth: count > 0 ? "4px" : "0",
                }}
              />
            </div>
            <span className="w-12 text-right tabular-nums text-fl-sand/80">
              {count}{" "}
              <span className="text-fl-sand/40">({pct}%)</span>
            </span>
          </div>
        );
      })}
    </div>
  );
};
